import * as React from "react";
import defaultImage from "src/assets/images/default-header.png";
import { useAppContext } from "src/context/AppContext";
import LanguageSelect from "../LanguageSelect";
import {
  BannerTopIconWrapper,
  BannerWrapper,
  Container,
  Overlay,
} from "./styled";

const Banner = ({ children }: { children?: React.ReactNode }) => {
  const { selectedExhibitId, getExhibit } = useAppContext();
  const exhibit = getExhibit(selectedExhibitId);
  const [banner, setBanner] = React.useState(
    exhibit?.exhibitImage || exhibit?.exhibitImageThumb
  );

  // set the banner image in useEffect
  React.useEffect(() => {
    if (selectedExhibitId) {
      const exhibit = getExhibit(selectedExhibitId);
      setBanner(exhibit?.exhibitImage || exhibit?.exhibitImageThumb);
    }
  }, [exhibit, getExhibit, selectedExhibitId]);

  return (
    <BannerWrapper as="div" $image={banner || defaultImage}>
      <Container>
        <BannerTopIconWrapper>
          <LanguageSelect />
        </BannerTopIconWrapper>
      </Container>
      {children}
      {/* show gradient overlay if there is custom image */}
      {banner && <Overlay />}
    </BannerWrapper>
  );
};

export default Banner;
